import { Component, OnInit, ViewChild } from '@angular/core';
import { UserRoleService } from 'src/app/services/user-role.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ListRolesService } from './list-roles.service';
import { take } from 'rxjs/operators';
@Component({
  selector: 'app-list-roles',
  templateUrl: './list-roles.component.html',
  styleUrls: ['./list-roles.component.scss']
})
export class ListRolesComponent implements OnInit {
  isCreateAndEdit: boolean = false;
  updatedRoleList;
  displayedColumns: string[] = ['role', 'description', 'modules', 'action'];
  roleModuleList: any[] = [];
  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;
  pageSize = 25;
  pageSizeOptions = [25, 50, 100];
  totalElementCount = 0;
  pageEvent: PageEvent;
  pageIndex: number = 1;
  public idList: number[] = [];
  selectedRows: any[] = [];
  form: FormGroup;
  displayPopup: boolean = false;
  applications: any[] = [];

  constructor(
    private userRoleService: UserRoleService,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private listRolesService: ListRolesService
  ) {
    this.updatedRoleList = [];
  }

  ngOnInit() {
    this.authenticationService.currentUser.subscribe((data) => {
      if (data) {
        data['permissions'].forEach(el => {
          if (el === 'EDIT_ROLE') {
            this.isCreateAndEdit = true;
          }
        });
      }
    });

    this.form = this.fb.group({
      application: [null, Validators.required]
    });

    this.getApplications();

    this.getRolePermissionList();

  }

  getApplications() {
    this.listRolesService.onGetApplications()
      .pipe(take(1))
      .subscribe((data: any) => {
        this.applications = data.map(x => {
          return {
            id: x.id,
            name: x.name
          }
        });
      });
  }

  getRolePermissionList() {
    this.userRoleService.getRoleByCompanyId(parseInt(sessionStorage.getItem('selectedCompanyId'))).subscribe(data => {
      this.roleModuleList = data;
    });
  }

  payload = {
    pageNumber: this.pageIndex,
    pageSize: this.pageSize,
  }

  paginationEvent(event) {
    this.payload.pageNumber = event.page + 1;
    this.payload.pageSize = event.rows;
    this.getRolePermissionList();
  }

  handleEdit(role) {
    localStorage.setItem('role', JSON.stringify(role));
    this.router.navigate(['../createrole'], { relativeTo: this.route });
  }

  createNewRole() {
    localStorage.removeItem('role');
  }

  deletePrompt(id) {
    let title: string = 'Delete this role';
    let message: string = 'Before deleting this role, please make sure that you have no existing user assigned with this role!';
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '400px',
      height: 'auto',
      data: {
        update: { title, message },
        buttons: ['No', 'Yes']
      }
    }).afterClosed().subscribe(reason => {
      reason != false ? this.handleDelete(id) : '';
    });
  }

  handleDelete(id) {
    const idList = [];
    idList.push(id);

    this.userRoleService.deleteRoles(idList).subscribe(data => {
      if (data['status'] === 200) {
        this.toastr.success("Role removed for an employee.", 'Success');
        this.getRolePermissionList();
      }
    });
  }

  showDialog() {
    this.displayPopup = true;
  }

  onSubmit() {
    if (this.form.valid) {
      this.listRolesService.onSaveAppRoleCompanyMapping({
        companyId: parseInt(sessionStorage.getItem('selectedCompanyId')),
        applicationId: this.form.value.application,
        roleIds: this.selectedRows.map(x => x.id)
      })
        .pipe(take(1))
        .subscribe((response: boolean) => {
          if (response) {
            this.toastr.success("Roles are mapped to the application Successfully", 'Success');
            this.displayPopup = false;
            this.getRolePermissionList();
          }
        });
    }
  }

}
